import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { IoKeySharp } from "react-icons/io5";
import { MdKeyboardBackspace } from "react-icons/md";
import { Alert, Form, Input } from 'antd';

import classes from './MaskRecovery.module.scss'
import axios from '../../../../services/axios'
import { setMessage } from "../../../../store/actions";

import PasswordRecoveryWrapper from "../PasswordRecoveryWrapper";
import SubmitButton from "../../../UI/SubmitButton/SubmitButton";

const MaskRecovery = (props) => {
    const dispatch = useDispatch()

    const [contact, setContact] = useState(null)
    const [loading, setLoading] = useState(false)
    const [ifError, setIfError] = useState(false)
    const [contactMissingPart, setContactMissingPart] = useState('')
    const [contactValueStart, setContactValueStart] = useState('')
    const [contactValueEnd, setContactValueEnd] = useState('')
    const [ifUnmount, setIfUnmount] = useState(false)

    useEffect(() => {
        if (props.location.state?.contact) {
            setContact(props.location.state.contact)

            const maskedValue = props.location.state.contact.contactValue
            setContactValueStart(maskedValue.substring(0, maskedValue.indexOf('*')))
            setContactValueEnd(maskedValue.substring(maskedValue.lastIndexOf('*') + 1))
        }
        else props.history.push("/password-recovery")
    }, [props.history, props.location])

    const setContainerStylesOnUnmount = () => {
        if (ifUnmount) return { opacity: 0, transform: 'translateY(20px)' }
        else return { opacity: 1, transform: 'translateY(0)' }
    }

    const checkContact = () => {
        setIfError(false);
        setLoading(true);
        axios.post('/api/v1/settings/contact/exist', {
            contactValue: `${contactValueStart}${contactMissingPart}${contactValueEnd}`,
            login: props.location.state.login
        })
            .then((response) => contactIsValid(response))
            .catch((error) => contactIsInvalid(error))
    }

    const contactIsValid = (response) => {
        setLoading(false)
        setIfUnmount(true)
        setTimeout(() => {
            props.history.replace({
                pathname: '/new-password',
                state: {
                    contact: { ...props.location.state.contact, ...response.data.contacts[0] },
                    remainingAttempts: response.data.remainingAttempts,
                    login: props.location.state.login,
                    prevPath: props.location.pathname
                }
            })
        }, 400);
    }

    const contactIsInvalid = (error) => {
        setLoading(false)
        if (error?.response?.status === 429 && error?.response?.data.banExpiredTime) {
            props.history.replace({ pathname: '/password-recovery/error', state: { time: error.response.data.banExpiredTime } });
        } else if (error.response.status === 404) {
            setIfError(true)
        } else {
            dispatch(setMessage({ type: 'warning', text: "Не удалось подключиться к серверу." }));
        }
    }

    return (
        <PasswordRecoveryWrapper
            icon={<IoKeySharp size={35} />}
            title={props.location.state?.contact ? `Подтвердите ${props.location.state.contact.name.toLowerCase()}` : 'Подтвердите контакт'}>
            <button className={classes.goBackButton} onClick={() => props.history.goBack()}>
                <MdKeyboardBackspace size={35} />
            </button>
            {contact && <div className={`${classes.container} MaskRecovery_container_color`} style={setContainerStylesOnUnmount()}>
                <div className={classes.details}>
                    Данный контакт будет использо&shy;ваться для восстановления пароля.
                    Введите <b><u>недостающую часть</u></b> для подтверждения.
                </div>
                <Form
                    name="mask_recovery"
                    scrollToFirstError={true}
                    onFinish={checkContact}>
                    <Form.Item>
                        <div className={classes.contactValue}>{contact.contactValue}</div>
                    </Form.Item>

                    <Form.Item
                        name="contact"
                        rules={contact.maskRecoveryValidationRules}
                        hasFeedback={true}>
                        <Input
                            autoComplete="off"
                            maxLength={contact.maxLength}
                            addonBefore={contactValueStart}
                            addonAfter={contactValueEnd}
                            value={contactMissingPart}
                            onChange={(e) => setContactMissingPart(e.target.value.trim())}
                        />
                    </Form.Item>

                    <Form.Item>
                        <SubmitButton
                            type="submit"
                            text="Отправить"
                            block
                            loading={loading} />
                    </Form.Item>

                    {(ifError) && <Form.Item>
                        <Alert
                            message="Ошибка!"
                            description="Неверный контакт. Обратитесь в деканат для актуализации данных"
                            type="error"
                            showIcon
                            className={classes.errorContainer}
                        />
                    </Form.Item>}
                </Form>
            </div>}
        </PasswordRecoveryWrapper>
    )
}

export default MaskRecovery;